export const PAGE_MESSAGE_HEADER_FOR_ZIP_CODE_CHANGE = 'Note:';
export const PAGE_MESSAGE_BODY_FOR_ZIP_CODE_CHANGE =
  'Available incentives have been updated based on customer new ZIP code, please check incentives';
